import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';

interface Auditoria {
  id: number;
  cliente: string;
  dataInicio: Date;
  dataFim: Date;
  tipo: string;
  status: string;
  responsavel: string;
  pontuacao: number;
}

@Component({
  selector: 'app-visualizar-auditoria',
  templateUrl: './visualizar-auditoria.component.html',
  styleUrls: ['./visualizar-auditoria.component.scss']
})
export class VisualizarAuditoriaComponent implements OnInit {
  filtroForm: FormGroup;
  auditorias: Auditoria[] = [];
  dtOptions: DataTables.Settings = {};
  tiposAuditoria = [
    { id: 'interna', nome: 'Interna' },
    { id: 'externa', nome: 'Externa' },
    { id: 'qualidade', nome: 'Qualidade' }
  ];
  statusAuditoria = [
    { id: 'em_andamento', nome: 'Em Andamento' },
    { id: 'concluida', nome: 'Concluída' },
    { id: 'pendente', nome: 'Pendente' },
    { id: 'cancelada', nome: 'Cancelada' }
  ];

  constructor(private fb: FormBuilder) {
    this.filtroForm = this.fb.group({
      cliente: [''],
      tipo: [''],
      status: [''],
      dataInicio: [''],
      dataFim: ['']
    });
  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      language: {
        url: '//cdn.datatables.net/plug-ins/1.13.7/i18n/pt-BR.json'
      }
    };
    this.carregarAuditorias();
  }

  carregarAuditorias() {
    // Implementar chamada à API
    this.auditorias = [
      {
        id: 1,
        cliente: 'Auditoria 01',
        dataInicio: new Date('2024-03-01'),
        dataFim: new Date('2024-03-15'),
        tipo: 'interna',
        status: 'concluida',
        responsavel: 'João Silva',
        pontuacao: 85
      },
      {
        id: 2,
        cliente: 'Auditoria 02',
        dataInicio: new Date('2024-03-10'),
        dataFim: new Date('2024-03-25'),
        tipo: 'externa',
        status: 'em_andamento',
        responsavel: 'Maria Santos',
        pontuacao: 0
      },
      {
        id: 3,
        cliente: 'Auditoria 03',
        dataInicio: new Date('2024-02-15'),
        dataFim: new Date('2024-02-28'),
        tipo: 'qualidade',
        status: 'concluida',
        responsavel: 'Pedro Oliveira',
        pontuacao: 92
      },
      {
        id: 4,
        cliente: 'Auditoria 04',
        dataInicio: new Date('2024-03-05'),
        dataFim: new Date('2024-03-20'),
        tipo: 'interna',
        status: 'pendente',
        responsavel: 'Ana Costa',
        pontuacao: 0
      },
      {
        id: 5,
        cliente: 'Auditoria 05',
        dataInicio: new Date('2024-02-20'),
        dataFim: new Date('2024-03-05'),
        tipo: 'externa',
        status: 'cancelada',
        responsavel: 'Carlos Lima',
        pontuacao: 0
      }
    ];
  }

  aplicarFiltros() {
    // Implementar lógica de filtro
    console.log('Aplicar filtros:', this.filtroForm.value);
    this.carregarAuditorias();
  }

  limparFiltros() {
    this.filtroForm.reset();
    this.carregarAuditorias();
  }

  getTipoNome(tipoId: string): string {
    const tipo = this.tiposAuditoria.find(t => t.id === tipoId);
    return tipo ? tipo.nome : tipoId;
  }

  getStatusNome(statusId: string): string {
    const status = this.statusAuditoria.find(s => s.id === statusId);
    return status ? status.nome : statusId;
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'concluida':
        return 'badge-success';
      case 'em_andamento':
        return 'badge-primary';
      case 'pendente':
        return 'badge-warning';
      case 'cancelada':
        return 'badge-danger';
      default:
        return 'badge-secondary';
    }
  }

  getPontuacaoClass(pontuacao: number): string {
    if (pontuacao >= 90) return 'text-success';
    if (pontuacao >= 70) return 'text-warning';
    return 'text-danger';
  }
} 